import { getDateFormat1 } from "./getDateFormat1";

export const dateFormater = (val) => {
  switch (val) {
    case "01":
      return "1";
    case "02":
      return "2";
    case "03":
      return "3";
    case "04":
      return "4";
    case "05":
      return "5";
    case "06":
      return "6";
    case "07":
      return "7";
    case "08":
      return "8";
    case "09":
      return "9";
    default:
      return val;
  }
};

export const dateFormaterSpecific = (date) => {
  let targetDate = date ? new Date(date) : new Date();
  let today = new Date();
  let yesterday = new Date(today);

  yesterday = yesterday.setDate(yesterday.getDate() - 1);
  yesterday = new Date(yesterday);

  targetDate = targetDate.toDateString();
  today = today.toDateString();
  yesterday = yesterday.toDateString();

  if (targetDate === today) {
    return "Today";
  } else if (targetDate === yesterday) {
    return "Yesterday";
  } else {
    return getDateFormat1(targetDate);
  }
};
